
    //! yukData.yuklemeTuru.value
    //! aracData.aracTypeName 
    //! aracData.aracTypeId 
    //! aracData.kasaTypeName 
    //! aracData.kasaTypeId
    //! paymentData.fiyatlandirmaType.value
    //! paymentData.odemeSekli.value
    //! yukData.agirlikBirim.value
    //! yukData.toplamAgirlik
    //! yukData.yukTuru

    const submitLoadPermission = (routeData, aracData, paymentData, yukData, paketlemeData, distanceData, selectedProjectAddLoad, isKayit=false) => {

        const isErrorList = routeData.map(item => {
            return {locationType: item.locationType, city: item.locationData.il, town: item.locationData.ilce, lat: item.locationData.lat, lng: item.locationData.lng, date: item.date}
        }).map(innerItem => {
            if(innerItem.locationType === "yukleme"){
                if(innerItem.city && innerItem.town && innerItem.lat && innerItem.lng && (innerItem.date || !isKayit)){
                    return true
                }else{
                    return false
                }
            }
    
            else if(innerItem.locationType === "bosaltma"){
                if( innerItem.city && innerItem.town && innerItem.lat && innerItem.lng) {
                    return true
                }else{
                    return false
                }
            }
            else{
                return false
            }
        })
    
    
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    
    const rld = JSON.parse(storage.getItem("rld"))
      
    
        
const yukverenIds =
  rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" ||
  rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228";

const priceOk = yukverenIds
  ? Boolean(selectedProjectAddLoad?.id)
  : paymentData.fiyatYayinlansin
    ? Boolean(paymentData.hedefNakliyefiyat)
    : true;

if (
  yukData.yuklemeTuru.value !== "" &&
  aracData.aracTypeName &&
  aracData.aracTypeId &&
  aracData.kasaTypeName &&
  aracData.kasaTypeId &&
  paymentData.fiyatlandirmaType.value !== "" &&
  priceOk &&
  paymentData.odemeSekli.value !== "" &&
  yukData.agirlikBirim.value !== "" &&
  (yukData.agirlikBirim.value === 3 || yukData.toplamAgirlik !== "") &&
  yukData.yukTuru &&
  !isErrorList.includes(false)
) {
  console.log("true");
  return true;
}
else{
    console.log("false");
    return false;
}
    
    }
    
    export default submitLoadPermission